import { EventType, StateType } from 'src/types/redux/user.redux.types';
import { UsersTableResultType } from 'src/types/services/user-service.type';

const isUserInRecordAvailableInCurrentUserAdminEvents = (
  usersList: UsersTableResultType[],
  currentUserAdminEvents: EventType[],
  formUsername: string,
) => {
  return currentUserAdminEvents.some((e) =>
    usersList.find((user) => user.userName === formUsername)?.events.some((userEvent) => userEvent.id === e.id),
  );
};

export const isUserOperationsDisabledForCurrentUser = (
  usersList: UsersTableResultType[],
  currentUserAdminEvents: EventType[],
  userState: StateType,
  formUsername: string,
  permissionListUserRight: boolean | undefined,
) => {
  if (userState.userName === 'Admin') {
    return false;
  }

  if (permissionListUserRight) {
    return true;
  } else if (formUsername === 'Admin' && !(userState.userName === 'Admin')) {
    return true;
  } else if (!isUserInRecordAvailableInCurrentUserAdminEvents(usersList, currentUserAdminEvents, formUsername)) {
    return true;
  }

  return false;
};

export const isCurrentUserAdminInDatabase = (
  userState: StateType,
  currentUserAdminEvents: EventType[],
  databaseId: string,
) => {
  if (userState.userName === 'Admin') {
    return true;
  }

  return currentUserAdminEvents.some((e) => e.id === databaseId);
};
